import { connect } from 'react-redux';
import storage from 'app/services/storage';
import sessionService from 'app/services/session';
import sessionsModule from 'app/store/sessions';
import orderModule from 'app/store/order';
import layoutModule from 'app/store/layout';
import paymentModule from 'app/store/payment';
import Wizard from './Wizard.component';

const { wizardClear } = sessionsModule.actions;
const { orderCancelRequest, clearOrder } = orderModule.actions;
const { clearErrorApi, createToast, setLoader } = layoutModule.actions;
const { setPaymentStatus } = paymentModule.actions;

const mapStateToProps = ({ sessions: { session }, order, layout, payment: { status, giftCardpayment } }) => {
  const sessionIsLoaded = !!session;
  return {
    sessionIsLoaded,
    isOrdered: !!order,
    error: layout.apiError,

    userSessionId: order ? order?.userSessionId : null,
    redSessionTTL: sessionIsLoaded ? session?.restrictions?.originalRestrictions?.redSessionTTL : null,
    orderTTL: sessionIsLoaded ? session?.restrictions?.originalRestrictions?.orderTTL : null,
    showtime: sessionIsLoaded ? session?.session?.showtime : null,
    isPaymentStatus: !!status,
    giftCardpayment: !!giftCardpayment,

    orderId: storage.getOrderId(),
    previousRoute: sessionService.getRoute(),

    saveOrderId: id => {
      storage.setOrderId(id);
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearError: () => dispatch(clearErrorApi()),
    clearOrder: () => dispatch(clearOrder()),
    notify: (...params) => dispatch(createToast(...params)),
    wizardClear: () => dispatch(wizardClear()),
    cancelOrder: orderId => {
      storage.removeOrderId();
      dispatch(orderCancelRequest(orderId));
    },
    clearPaymentStatus: () => dispatch(setPaymentStatus(null)), setLoaderData: setLoader,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wizard);
